import React, { useState } from 'react';
import { formatPhoneNumber, getPartOfDay } from './extensions';
import { affiliateData, AffiliateLink } from '../data/AffiliateData';
import { useTheme } from '../ThemeContext';

export default function Person() {
    const { isDarkMode } = useTheme();
    const [copyText, setCopyText] = useState('Copy');

    const handleCopy = (link) => {
        navigator.clipboard.writeText(link);
        setCopyText('Copied!');

        setTimeout(() => {
            setCopyText('Copy');
        }, 3000); // Reset after 3 seconds
    };

    return (
        <div className='person flex lg:flex-row flex-col gap-4 items-start lg:w-[90%] lg:ml pt-4 pb-2 px-5 font-mont justify-between'>
            <div className='flex flex-col items-start'>
                <p className={`personName text-xl lg:text-2xl font-bold ${isDarkMode && 'text-white'}`}>
                    {getPartOfDay() + affiliateData.account.accountName + '.'}
                </p>
                <p className={`personEmail ${isDarkMode && 'text-white'}`}>{affiliateData.account.accountEmail}</p>
                <p className={`${isDarkMode && 'text-white'}`}>{formatPhoneNumber(affiliateData.account.accountPhone)}</p>
            </div>

            <div className='flex flex-col items-start lg:w-1/3 w-full'>
                <p className={`personEmail ${isDarkMode && 'text-white'}`}>Affiliate URLs:</p>
                {affiliateData.account.accountLinks.map((_link) => {
                    const link = new AffiliateLink(_link)
                    return (
                        <div className={`flex items-center mt-1 p-2 rounded-lg w-full ${isDarkMode ? 'bg-gray-700' : 'bg-gray-100'}`}>
                            <input
                                type='text'
                                value={link.linkURL}
                                readOnly
                                className={`bg-transparent text-sm outline-none w-full ${isDarkMode ? 'text-white' : 'text-black'}`}
                            />
                            <button
                                onClick={() => handleCopy(link.linkURL)}
                                className='ml-2 p-1 bg-blue-500 hover:bg-blue-600 text-white rounded-md text-xs transition-all duration-300'
                            >
                                {copyText}
                            </button>
                        </div> 
                    )
                })}
            </div>
        </div>
    );
}